function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 3.60002C13.1031 3.60002 14.1954 3.8173 15.2146 4.23944C16.2337 4.66158 17.1597 5.28032 17.9397 6.06033C18.7197 6.84034 19.3385 7.76635 19.7606 8.78548C20.1828 9.80462 20.4 10.8969 20.4 12C20.4 13.1031 20.1828 14.1954 19.7606 15.2146C19.3385 16.2337 18.7197 17.1597 17.9397 17.9397C17.1597 18.7197 16.2337 19.3385 15.2146 19.7606C14.1954 20.1828 13.1031 20.4 12 20.4V3.60002ZM12 2.40002C9.45395 2.40002 7.01215 3.41145 5.2118 5.2118C3.41145 7.01215 2.40002 9.45395 2.40002 12C2.40002 14.5461 3.41145 16.9879 5.2118 18.7883C7.01215 20.5886 9.45395 21.6 12 21.6C14.5461 21.6 16.9879 20.5886 18.7883 18.7883C20.5886 16.9879 21.6 14.5461 21.6 12C21.6 9.45395 20.5886 7.01215 18.7883 5.2118C16.9879 3.41145 14.5461 2.40002 12 2.40002Z",
  fill: "currentcolor"
});

const SvgThemeIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThemeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/theme_icon.3ac95152.svg";
export { ForwardRef as ReactComponent };